module.exports = __webpack_public_path__ + "static/alum4-cc61823f90fb324bc7e5fafaf10195dc.png";